import script from "./VFeedStoryRecord.vue?vue&type=script&setup=true&lang=ts"
export * from "./VFeedStoryRecord.vue?vue&type=script&setup=true&lang=ts"

import "./VFeedStoryRecord.vue?vue&type=style&index=0&id=6861f909&lang=scss"

const __exports__ = script;

export default __exports__